import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Slide,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import React, { useEffect, useState } from "react";
import { FC } from "react";
import AccountSelectionDialog from "./AccountSelectionDialog";
import useStore from "../../../../../helpers/useStore";
import { UserContext } from "../../../../../stores/User/User.provider";
import { Share, Mail, CurrencyExchange, PriceCheck, ContentCut } from "@mui/icons-material";
import { BillingTypeEnum } from "../types/insuranceBills.types";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

interface PaymentMethodDialogProps {
  open: boolean;
  handleClose: () => void;
}

const PaymentMethodDialog: FC<PaymentMethodDialogProps> = ({
  open,
  handleClose,
}) => {
  const [openDialog, setOpenDialog] = useState({
    GKV: false,
    CORRECTION: false,
    LINE_ITEM_CORRECTION: false,
    PAPER: false,
    ZUZAHLUNG: false,
  });

  const handleOpenDialog = (type: string) => {
    setOpenDialog({ ...openDialog, [type]: true });
  };

  // console.log("Open Dialog", openDialog);

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Rechnungen an den Kostenträger"}</DialogTitle>
        <DialogContent sx={{ marginTop: 2 }}>
          <Grid container spacing={1} justifyContent={"space-evenly"}>
            <Grid item>
              <List>
                <ListItemButton
                  onClick={() => handleOpenDialog(BillingTypeEnum.GKV)}
                >
                  <ListItemIcon>
                    <Share />
                  </ListItemIcon>
                  <ListItemText
                    primary="GKV digitale Abrechnung"
                    secondary="Elektronischen Abrechnungsverfahren mit den gesetzlichen Krankenkassen"
                  />
                </ListItemButton>
                <ListItemButton
                  onClick={() => handleOpenDialog(BillingTypeEnum.CORRECTION)}
                >
                  <ListItemIcon>
                    <CurrencyExchange />
                  </ListItemIcon>
                  <ListItemText
                    primary="GKV Korrekturverfahren"
                    secondary="Korrekturverfahren für gestzliche Krankenkassen"
                  />
                </ListItemButton>
                <ListItemButton
                  onClick={() => handleOpenDialog(BillingTypeEnum.LINE_ITEM_CORRECTION)}
                >
                  <ListItemIcon>
                    <ContentCut />
                  </ListItemIcon>
                  <ListItemText
                    primary="GKV Positionskorrektur"
                    secondary="Korrektur einzelner Positionen einer Rechnung"
                  />
                </ListItemButton>
                <ListItemButton
                  onClick={() => handleOpenDialog(BillingTypeEnum.ZUZAHLUNG)}
                >
                  <ListItemIcon>
                    <PriceCheck />
                  </ListItemIcon>
                  <ListItemText
                    primary="GKV Zuzahlungsforderung"
                    secondary="Für die Rückforderung erstellt der Leistungserbringer eine neue Rechnung"
                  />
                </ListItemButton>
                <Divider />
                <ListItemButton
                  onClick={() => handleOpenDialog(BillingTypeEnum.PAPER)}
                >
                  <ListItemIcon>
                    <Mail />
                  </ListItemIcon>
                  <ListItemText
                    primary="Papier Abrechnung"
                    secondary="Rechnung per Post an Bundeswehr, BG, Feuerwehr, Polizei"
                  />
                </ListItemButton>
              </List>
            </Grid>
            <Grid item>
              {openDialog.PAPER && (
                <AccountSelectionDialog
                  paymentType={BillingTypeEnum.PAPER}
                  isOpen={openDialog.PAPER}
                  onCancel={handleClose}
                />
              )}

              {openDialog.GKV && (
                <AccountSelectionDialog
                  paymentType={BillingTypeEnum.GKV}
                  isOpen={openDialog.GKV}
                  onCancel={handleClose}
                />
              )}

              {openDialog.ZUZAHLUNG && (
                <AccountSelectionDialog
                  paymentType={BillingTypeEnum.ZUZAHLUNG}
                  isOpen={openDialog.ZUZAHLUNG}
                  onCancel={handleClose}
                />
              )}

              {openDialog.CORRECTION && (
                <AccountSelectionDialog
                  paymentType={BillingTypeEnum.CORRECTION}
                  isOpen={openDialog.CORRECTION}
                  onCancel={handleClose}
                />
              )}

              {openDialog.LINE_ITEM_CORRECTION && (
                <AccountSelectionDialog
                  paymentType={BillingTypeEnum.LINE_ITEM_CORRECTION}
                  isOpen={openDialog.LINE_ITEM_CORRECTION}
                  onCancel={handleClose}
                />
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Schließen</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default PaymentMethodDialog;
